// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import * as localStorageService from 'components/localStorageService'
import React from 'react'

import { Avatar, Grid, Typography } from '@mui/material'
import * as applicationSlice from 'features/application/application-slice'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import { getUserClaims } from 'features/application/application-slice'
import {
    get_all_profile,
    get_selected_profile,
    setSelectedprofile,
} from 'features/profile/profile-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function ProfileListComponent() {
    // Generate Grid
    const theme = useTheme()
    let dispatch = useDispatch()
    let claims = useSelector(getUserClaims)
    const customization = useSelector((state: any) => state.customization)
    let selectedProfile = useSelector(get_selected_profile);
    let profile_list = useSelector(get_all_profile)

    useEffect(() => {
        if (claims?.fire_user) {
            dispatch(autoThunks.get_profiles_list({ userId: claims?.fire_user }))
        }
    }, [claims?.fire_user])

    function scaleDownImage(src: string) {
        let sizes = ['1024', '512', '256', '128']
        let pos = sizes.findIndex((v) => `${src}`.indexOf(v) !== -1)
        if (pos !== -1) {
            return src.replace(sizes[pos], '64')
        }
        return src
    }

    function viewprofilelistcomponent(comp: any): any {
        return (
            <>
                <div>
                    <List>
                        {profile_list.map((p) => {
                            return (
                                <ListItemButton
                                    selected={p?.id === selectedProfile?.id}
                                    sx={{
                                        padding: 0,
                                        borderRadius: `${customization.borderRadius}px`,
                                    }}
                                    onClick={() => {
                                        localStorageService.store(
                                            {
                                                profileId: p?.id,
                                                date: Date.now(),
                                            },
                                            'ProfileId',
                                        )
                                        dispatch(setSelectedprofile(p.id))
                                        dispatch(applicationSlice.setProfileImage(p.profileImage))
                                        dispatch(applicationSlice.setProfileName(p.name))
                                    }}
                                >
                                    <ListItemIcon>
                                        <Avatar
                                            src={scaleDownImage(p.profileImage)}
                                            sx={{
                                                ...theme.typography.largeAvatar,
                                                margin: '8px 8px 8px 8px !important',
                                                cursor: 'pointer',
                                            }}
                                            color="inherit"
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Grid
                                                container
                                                spacing={1}
                                                justifyContent="space-between"
                                            >
                                                <Grid item>
                                                    <Typography variant="h3">{p.name}</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                </ListItemButton>
                            )
                        })}
                    </List>
                </div>
            </>
        )
    }

    let output_viewprofilelistcomponent = viewprofilelistcomponent(null)

    return output_viewprofilelistcomponent
}
